import yup from '@/plugins/yup'
import { i18n } from '@/plugins/i18n'
import ReportSearchBarSchema from '@/schemas/ReportSearchBarSchema'

const { t } = i18n.global

const periodFieldSchema = yup
  .array()
  .of(yup.date())
  .required(
    t('errors.required', {
      label: t('dashboard.header.actions.search.fields.period'),
    }),
  )
  .test('range-less-than-two-month', t('dashboard.header.actions.search.errors.range_less_than_two_month'), (value) => {
    if (!value?.[0] || !value?.[1]) return false
    const start = value[0]
    const end = value[1]
    return end.getTime() - start.getTime() < 1000 * 60 * 60 * 24 * 62
  })

const groupFieldSchema = yup.object().required(
  t('errors.required', {
    label: t('dashboard.header.actions.search.fields.group'),
  }),
)

/** Schema do formulário: campos de comparação ficam opcionais até o submit. */
const reportSearchPanelSchema = ReportSearchBarSchema.shape({
  shift: yup.mixed().nullable().optional(),
  compareGroup: yup.mixed().nullable().optional(),
  comparePeriod: yup.mixed().nullable().optional(),
  compareShift: yup.mixed().nullable().optional(),
})

/** Validado manualmente no submit quando a comparação está habilitada. */
const compareSearchFieldsSchema = yup.object({
  compareGroup: groupFieldSchema,
  comparePeriod: periodFieldSchema,
})

export { compareSearchFieldsSchema, groupFieldSchema, periodFieldSchema, reportSearchPanelSchema }
export default reportSearchPanelSchema
